import { render, staticRenderFns } from "./ISABedExitLicense.vue?vue&type=template&id=6b30d032&scoped=true&"
import script from "./ISABedExitLicense.vue?vue&type=script&lang=js&"
export * from "./ISABedExitLicense.vue?vue&type=script&lang=js&"
import style0 from "./ISABedExitLicense.vue?vue&type=style&index=0&id=6b30d032&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b30d032",
  null
  
)

export default component.exports